import * as React from 'react';
import { HotKeys } from 'react-hotkeys';
import { PromptModalState, InputModalHostProps } from './types';
import { withDropdownMenu } from 'ui/common/dropdown-menu';
import { DropdownMenuContext } from 'ui/common/dropdown-menu/types';

export class InputModalComponent extends React.Component<InputModalHostProps & DropdownMenuContext, PromptModalState> {
  public state: Readonly<PromptModalState> = {
    isOpen: false
  };

  public openModal = (e: React.SyntheticEvent<any>) => {
    e && e.preventDefault();
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  private closeModal = () => {
    this.props.handleDropdownHide && this.props.handleDropdownHide();
    this.setState({
      isOpen: false
    });
  };

  private handleContinue = (e: React.SyntheticEvent<any>, ...args:number[]|string[]) => {
    e && e.preventDefault();
    this.closeModal();
    this.props.onContinue && this.props.onContinue(...args);
  };

  private handleCancel = (e: React.SyntheticEvent<any>) => {
    e && e.preventDefault();
    this.closeModal();
    this.props.onCancel && this.props.onCancel();
  };

  private keyMap: any = {
    escapeKey: ['esc']
  };

  private handlerHotkeys: any = {
    escapeKey: () => this.closeModal()
  };

  public render() {

    return  (
      <HotKeys keyMap={this.keyMap} handlers={this.handlerHotkeys}>
        {
          this.props.children
            ?
              this.props.children({
                ...this.props,
                ...this.state,
                ...{
                  onOpen: this.openModal ,
                  onContinue: this.handleContinue,
                  onCancel: this.handleCancel
                }
              })
            :
              null
        }
      </HotKeys>);
  }
}
/**
 * Host for components that need to open in modal state.
 * If the component was opened from a temporarily rendered component (dropdown menu etc), this component
 * will call `props.handleDropDownHide()` if avaliable.
 */
const component = withDropdownMenu(InputModalComponent);
export { component as InputModalHost };
